import React, { FC, useCallback } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import AppLayout from '../../../../components/layouts/AppLayout';
import ComposeContainer from '../../../../containers/compose';
import FeedKanbanHeader from '../../../../containers/header/feedKanban';
import Kanban from '../../../../containers/kanban';
import useParamHotelId from '../../../../hooks/router/params/useParamHotelId';
import useIsMobile from '../../../../hooks/useIsMobile';
import useIsTablet from '../../../../hooks/useIsTablet';
import { getTopicKanbanUrl } from '../../../urls/kanban';
import FeedFooter from '../../Feed/Feed/FeedFooter';
import FeedRightSidebar from '../../Feed/Feed/FeedRightSidebar';
import { shouldStopClickOutsideExec } from '../../Feed/Feed/helpers';

import useKanbanParams from '../hooks/useKanbanParams';

/**
 * Kanban page
 *
 * @returns The component itself
 */
const PageKanban: FC = () => {
  const hotelId = useParamHotelId();
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  const location = useLocation();
  const navigate = useNavigate();

  const {
    shouldShowKanban,
    shouldShowRightSidebarDesktop,
    shouldShowRightSidebarMobile,
    topicId,
  } = useKanbanParams();

  const clickOutsideStopExec = shouldStopClickOutsideExec(
    isMobile,
    isTablet,
    false,
    shouldShowRightSidebarDesktop,
  );

  const requestRightSidebarClose = useCallback(() => {
    navigate(getTopicKanbanUrl(hotelId, location, topicId));
  }, [hotelId, location, navigate, topicId]);

  return (
    <AppLayout
      footer={<FeedFooter />}
      header={<FeedKanbanHeader />}
      rightSidebar={{
        clickOutsideOptions: {
          onClick: requestRightSidebarClose,
          stopExec: clickOutsideStopExec,
        },
        component: <FeedRightSidebar />,
        shouldShowDesktop: shouldShowRightSidebarDesktop,
        shouldShowMobile: shouldShowRightSidebarMobile,
      }}
    >
      {shouldShowKanban && <Kanban />}
      <ComposeContainer nodeType="MESSAGE" />
    </AppLayout>
  );
};

export default PageKanban;
